import { SEED_TRACKING_HEADER_SOURCES } from '../types';
import type { SeedSettings, SeedSettingsResponse, SeedTrackingHeader, SeedTrackingHeaderSource } from '../types';

/** `SeedEmailRuns.tracking_header_value` is VARCHAR(100), prefix included. */
export const TRACKING_HEADER_VALUE_COLUMN_LENGTH = 100;

export function settingsMapper(response: SeedSettingsResponse): SeedSettings {
  // A server older than the per-source header names answers no list at all. Every source then
  // reads as "no entry", so the tab renders empty fields instead of throwing on a missing name.
  const entries = Array.isArray(response.tracking_headers) ? response.tracking_headers : [];

  const trackingHeaders = {} as Record<SeedTrackingHeaderSource, SeedTrackingHeader>;
  SEED_TRACKING_HEADER_SOURCES.forEach((source) => {
    const entry = entries.find((header) => header.source === source);
    trackingHeaders[source] = {
      source,
      name: typeof entry?.name === 'string' ? entry.name : null,
      // `null` until an admin saves this source's name for the first time.
      updatedBy: entry?.updated_by ?? null,
      updatedAt: entry?.updated_at ?? null,
    };
  });

  return {
    trackingHeaders,
    valueFormatExample: response.value_format_example,
    // The server's own bound for this stage. The fallback is the column width, which is right in
    // production and four characters generous anywhere else — a server that predates this field
    // still refuses the overflow with `seed_run_tracking_value_invalid`.
    valueMaxLength: response.value_max_length ?? TRACKING_HEADER_VALUE_COLUMN_LENGTH,
  };
}
